/**
 * @file クローンライブラリ
 * @namespace rahmen
 */
/**
 * @module dolly
 */

/**
 * クローンオブジェクト生成
 * @param {Object} obj クローン対象オブジェクト
 */
const clone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

export default {
  clone
}
